module.exports = __webpack_public_path__ + "img/f003840.png";